import { render, staticRenderFns } from "./ClientAddressesForm.vue?vue&type=template&id=22fc1b67&"
import script from "./ClientAddressesForm.vue?vue&type=script&lang=js&"
export * from "./ClientAddressesForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientAddressesForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports